/**
 * 分析获取hash数据
 *
 * @export
 * @returns {*}
 */
export function getHashParams(): any {
	const hashParams: any = {};

	if (window.location.href.indexOf('#') !== -1) {
		const hashUrl: string = window.location.hash;
		const hashUrlList: Array<string> = hashUrl.split('?');

		if (hashUrlList && hashUrlList.length === 2) {
			const rightParamsList: Array<any> = hashUrlList[1].split('&');

			while (rightParamsList.length) {
				const rightItem: string = rightParamsList.shift();
				const rightItemList: Array<string> = rightItem.split('=');

				if (rightItemList && rightItemList.length === 2) {
					hashParams[rightItemList[0]] = rightItemList[1];
				}
			}
		}
	}

	return hashParams;
}

/**
 * 节流自定义实现
 *
 * @export
 * @class LibsThrottler
 */
export class LibsThrottler {
	public callbackFun: any;
	public delay: number = 1000;
	public throttling: boolean = false;
	public timer: any = '';

	/**
	 *  throttle
	 *
	 * @param {*} fn 回调方法
	 * @param {number} [delay=1000] 延迟
	 * @returns {void}
	 *
	 * @memberOf ComponentThrotter
	 */
	public throttle(fn: any, delay: number = 1000): void {
		this.callbackFun = fn;
		this.delay = delay;

		if (!this.throttling) {
			this.startThrottle();
		} else {
			this.stopTimer();
			this.startThrottle();
		}
	}

	/**
	 * 停止定时器
	 *
	 * @private
	 *
	 * @memberOf LibsThrottler
	 */
	private stopTimer(): void {
		clearTimeout(this.timer);
	}

	/**
	 * 启动节流
	 *
	 * @private
	 *
	 * @memberOf LibsThrottler
	 */
	private startThrottle(): void {
		this.throttling = true;
		this.timer = setTimeout(() => {
			clearTimeout(this.timer);
			this.throttling = false;

			if (this.callbackFun) {
				const args: any = this.getArgs(this.callbackFun);
				// eslint-disable-next-line prefer-spread
				this.callbackFun.apply(this, args);
			}
		}, this.delay);
	}

	/**
	 * 获取函数参数
	 *
	 * @private
	 * @param {*} func
	 * @returns {*}
	 *
	 * @memberOf LibsThrottler
	 */
	private getArgs(func: any): any {
		// 首先匹配函数括弧里的参数
		const args = func.toString().match(/function\s.*?\(([^)]*)\)/)[1];

		// 分解参数成数组
		return args
			.split(',')
			.map((arg: any) =>
				// 去空格和内联注释
				arg.replace(/\/\*.*\*\//, '').trim()
			)
			.filter(
				(arg: any) =>
					// 确保没有undefineds
					arg
			);
	}
}

/** 生成随机数 */
export function generateRandomNumbers(): string {
	return Number(String(Math.random().toString()).substring(3, 8) + Date.now()).toString(36);
}

/** 下划线转驼峰 */
export function convertCamel(name: string): string {
	if (!name) {
		return '';
	}

	// eslint-disable-next-line no-useless-escape
	return name.replace(/\_(\w)/g, (all: any, letter: any): any => letter.toUpperCase());
}
